import React from 'react';
import styles from './Account.module.scss';

interface AccountSectionCardProps {
  title: string;
  description: string;
  /** Renders the section's Edit button when provided. */
  onEdit?: () => void;
  children: React.ReactNode;
}

/** White section card with title, muted description, and optional Edit button. */
export default function AccountSectionCard({ title, description, onEdit, children }: AccountSectionCardProps) {
  return (
    <div className={styles.sectionCard}>
      <div className={styles.sectionHead}>
        <h3 className={styles.sectionTitle}>{title}</h3>
        {onEdit && (
          <button type="button" className={styles.editBtn} onClick={onEdit}>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 20h9" />
              <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z" />
            </svg>
            Edit
          </button>
        )}
      </div>
      <p className={styles.sectionDesc}>{description}</p>
      <div className={styles.sectionBody}>{children}</div>
    </div>
  );
}

interface DetailRowProps {
  label: string;
  value: React.ReactNode;
}

/** Read-only label/value row. Empty values render as an italic "Not set". */
export function DetailRow({ label, value }: DetailRowProps) {
  const isEmpty = value === null || value === undefined || value === '';
  return (
    <div className={styles.detailRow}>
      <div className={styles.detailLabel}>{label}</div>
      {isEmpty ? (
        <div className={`${styles.detailValue} ${styles.detailValueEmpty}`}>Not set</div>
      ) : (
        <div className={styles.detailValue}>{value}</div>
      )}
    </div>
  );
}
